<div class="wrapper p-d-flex p-ai-center p-jc-center">
  <div class="content">

    <h3 class="headline" >{{ 'AUTH.ERROR.TITLE' | translate }}</h3>

    <p translate="AUTH.ERROR.INTRO"></p>
    <p translate="AUTH.ERROR.INTRO_2"></p>

    <pre *ngIf="debug" class="p-text-left">{{ debug | json}}</pre>
  </div>
</div>
